<template>
    <svg id="video_monitoring" viewBox="0 0 184.8 135.63" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
            <linearGradient id="a" x1="4.12" x2="192.96" y1="147.05" y2="10.02" gradientUnits="userSpaceOnUse">
                <stop stop-color="#ff34db" offset="0"/>
                <stop stop-color="#f835da" offset=".09"/>
                <stop stop-color="#e537d9" offset=".22"/>
                <stop stop-color="#c63bd6" offset=".37"/>
                <stop stop-color="#9a40d1" offset=".53"/>
                <stop stop-color="#6247cc" offset=".72"/>
                <stop stop-color="#1f4fc6" offset=".91"/>
                <stop stop-color="#0053c3" offset=".99"/>
            </linearGradient>
            <linearGradient id="e" x1="-8.41" x2="180.44" y1="129.79" y2="-7.24" xlink:href="#a"/>
            <linearGradient id="d" x1="6.03" x2="194.88" y1="149.68" y2="12.66" xlink:href="#a"/>
            <linearGradient id="c" x1="-25.17" x2="163.68" y1="106.69" y2="-30.34" xlink:href="#a"/>
            <linearGradient id="b" x1="8.69" x2="197.53" y1="153.35" y2="16.32" xlink:href="#a"/>
        </defs>
        <title>Asset 26</title>
        <g data-name="Layer 2">
            <g data-name="Layer 2">
                <path class="cls-1" d="m159 63a3 3 0 0 0-3 3 63.55 63.55 0 0 1-127.1 0 3 3 0 1 0-6 0 69.59 69.59 0 0 0 139.1 0 3 3 0 0 0-3-3z"/>
                <path class="cls-2" d="m49.94 94.17a2.93 2.93 0 0 0 1.51-0.41 3 3 0 0 0 1.1-4.13 48.28 48.28 0 0 1-2.55-5.09 3 3 0 1 0-5.56 2.35 52.51 52.51 0 0 0 2.87 5.77 3 3 0 0 0 2.63 1.51z"/>
                <path class="cls-3" d="M74.78,115.8a2.94,2.94,0,0,0,1,.18,3,3,0,0,0,1-5.88A46.17,46.17,0,0,1,58.26,97.58a3,3,0,0,0-4.57,4A52.66,52.66,0,0,0,74.78,115.8Z"/>
                <path class="cls-4" d="M184.1,1.09A3,3,0,0,0,181.78,0H3a3,3,0,0,0-3,3.56l7,38.62a3,3,0,0,0,3,2.48h6.28l5,11.6a3,3,0,0,0,2.78,1.82H160.68a3,3,0,0,0,2.77-1.82l5-11.6h6.28a3,3,0,0,0,3-2.48l7-38.62A3,3,0,0,0,184.1,1.09ZM158.69,52H26.11l-3.18-7.38h139Zm13.53-13.42H12.58L6.64,6H178.16Z"/>
                <path class="cls-5" d="m98.15 107.39a19 19 0 1 1 19-19 19 19 0 0 1-19 19zm0-33a14.07 14.07 0 1 0 14.06 14.06 14.08 14.08 0 0 0-14.06-14.08z"/>
                <circle class="cls-6" cx="98.15" cy="88.43" r="8.46"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "svg_videomonitoring"
    }
</script>

<style lang="scss" scoped>
    #video_monitoring{
        .cls-1{fill:url(#a);}
        .cls-2{fill:url(#e);}
        .cls-3{fill:url(#d);}
        .cls-4{fill:url(#c);}
        .cls-5{fill:url(#b);}
        .cls-6{fill:url(#linear-gradient-6);}
    }
</style>